import React, {useState} from "react";
import userApiClient from "../../../../common/apis/user/UserApiClient";
import {UserDto} from "../../../../common/apis/user/UserDto";
import {Button} from "../../../../components/button/Button";
import {CancelButton} from "../../../../components/button/CancelButton";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogActions from "../../../../components/dialogs/DialogActions";
import DialogContent from "../../../../components/dialogs/DialogContent";
import DialogContentText from "../../../../components/dialogs/DialogContentText";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import Snackbar from "../snackbar/Snackbar";
import {UsersTranslationKey} from "./UsersTranslationKey";

interface UserDeactivationDialogProps {
    open: boolean;
    user?: UserDto;
    onClose: (deactivated: boolean) => void;
}

export default function UserDeactivationDialog(props: UserDeactivationDialogProps) {
    const {open, user, onClose} = props;

    const [inProgress, setInProgress] = useState(false);

    function deactivate() {
        if (user) {
            setInProgress(true);
            userApiClient.activateUserByLogin(user.login, false)
                    .then(() => {
                        Snackbar.success(t(CommonTranslationKey.DATA_SAVED_SUCCESSFULLY));
                        onClose(true);
                    })
                    .catch(() => {
                        Snackbar.success(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED));
                    })
                    .finally(() => setInProgress(false));
        }
    }

    return (
        <Dialog
                open={open}
                onClose={() => onClose(false)}
                aria-labelledby="simple-dialog-title">
            <DialogTitle id="simple-dialog-title"
                    title={t(UsersTranslationKey.DEACTIVATE_USER_QUESTION_MARK)}
                    onDialogClosed={() => onClose(false)} />
            <DialogContent>
                <DialogContentText>
                    {t(UsersTranslationKey.USER_WILL_BE_DEACTIVATED)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={() => onClose(false)} disabled={inProgress}/>
                <Button label={t(UsersTranslationKey.DEACTIVATE)}
                        onClick={() => deactivate()}
                        disabled={inProgress}
                        variant={"contained"}
                        color={"error"} />
            </DialogActions>
        </Dialog>
    )
}
